import { createPortal } from 'react-dom'
import {
  ConfirmOverlay,
  ConfirmBox,
  ConfirmTitle,
  ConfirmMessage,
  ConfirmActions,
  ConfirmCancelBtn,
  ConfirmOkBtn,
} from './styles'

interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  variant?: 'default' | 'destructive';
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * ConfirmDialog — generic confirm modal, replaces window.confirm with the project's own design.
 */
export default function ConfirmDialog({
  title,
  message,
  confirmLabel,
  cancelLabel,
  variant = 'default',
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return createPortal(
    <ConfirmOverlay onClick={onCancel}>
      <ConfirmBox onClick={(e) => e.stopPropagation()}>
        <ConfirmTitle>{title}</ConfirmTitle>
        <ConfirmMessage>{message}</ConfirmMessage>
        <ConfirmActions>
          <ConfirmCancelBtn onClick={onCancel}>{cancelLabel}</ConfirmCancelBtn>
          <ConfirmOkBtn $variant={variant} onClick={onConfirm}>{confirmLabel}</ConfirmOkBtn>
        </ConfirmActions>
      </ConfirmBox>
    </ConfirmOverlay>,
    document.body,
  )
}
